"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTag = exports.INBOX_ADD_TAG = void 0;
var INBOX_ADD_TAG = "inbox/ADD_TAG";
exports.INBOX_ADD_TAG = INBOX_ADD_TAG;

var addTag = function addTag(messageId, tag) {
  return {
    type: INBOX_ADD_TAG,
    payload: {
      tag: tag,
      messageId: messageId
    }
  };
};

exports.addTag = addTag;